import {
    Box,
    Center,
    Text,
    Button,
    VStack,
    HStack,
} from '@chakra-ui/react';
import React, { useState, useEffect } from "react";
import { useParams, useNavigate, Link } from 'react-router-dom';
import { HorizontalBar, Pagination, PaginationButton } from "./style";
import "../index.css";
import { Table, Thead, Tbody, Tr, Th, Td } from 'react-super-responsive-table';
import 'react-super-responsive-table/dist/SuperResponsiveTableStyle.css';
import APIConfig from "../../api/APIConfig";
import ReactLoading from "react-loading";


function ListMentor() {
    const [listMentor, setListMentor] = useState([]);
    const [spinner, setSpinner] = useState(false);  
    const navigate = useNavigate();

    const { id } = useParams();

    const getListMentor = async(idMitra) => {  
        setSpinner(true);
        const response = await APIConfig.get(`/v1/mitra/list-mentor/${idMitra}`);
        const result = await response.data;
        setListMentor(result);
        setSpinner(false);
    };

    let data = listMentor;
    
    useEffect(() => {
        getListMentor(id);
    }, []);

    const [currentPage, setCurrentPage] = useState(1);
    const pageNumbers = [];
    for (let i = 1; i <= Math.ceil(data.length / 10); i++) {
        pageNumbers.push(i);
    }

    const indexOfLastData = currentPage * 10;
    const indexOfFirstData = indexOfLastData - 10;
    data = data.slice(indexOfFirstData, indexOfLastData);

    if (spinner) {
        return (
            <Center py={12}>
                <VStack align='stretch' fontFamily={'Inter'} pb={20}>
                <div className="section">
                    <div className="article">
                        <ReactLoading type="spin" color="#6554C0" />
                    </div>
                </div>
                </VStack>
            </Center>
              
        )
      }
    

    return(
        <div className="container">
        <Center py={6}>
        <VStack align='stretch' fontFamily={'Inter'} pb={20}>
            <Text
                pt={3}
                color={'gray.700'}
                fontWeight={600}
                fontSize={'2xl'}>
                List Mentor
            </Text>
            <HStack color={'gray.500'} pb={10}>
                <Link to=""> List Mentor</Link>
            </HStack>

            <Box paddingLeft={650} maxWidth={60} color={'gray.500'} pb={10}>
                <Button 
                    p={6}
                    onClick={() => navigate(`/mitra/profile/mentor/add/${id}`)}
                    colorScheme='purple' 
                    rounded={'xl'}
                    variant='solid'>
                    + Tambahkan Mentor
                </Button>
            </Box>
            
            <Box
                w='4xl'
                h="100%"
                border='1px'
                borderColor='gray.200'
                alignContent={'center'}
                rounded={'2xl'}
                p={2}
                overflow={'hidden'}>
                <VStack align='center'>
                    {data.length > 0 ? 
                        <Table style={{width: '95%', margin: '20px 0'}}>
                            <Thead className="head">
                                <Tr>
                                <Th className='layout'><p className='layoutp'>Nama</p></Th>
                                <Th className='layout'><p className='layoutp'>Email</p></Th>
                                <Th className='layout'><p className='layoutp'>Aktivitas</p></Th>
                                <Th className='layout'><p className='layoutp'>Jumlah Mentee</p></Th>
                                <Th className='layout'><p className='layoutp'>Laporan Belum Diperiksa</p></Th>
                                <Th className='layout'><p className='layoutp'>Posisi</p></Th>
                                <Th className='layout'><p className='layoutp'>Aksi</p></Th>
                                </Tr>
                            </Thead>
                            <Tbody>
                                {data.map((data)=>
                                    <Tr>
                                        <Td className='layout'><p className='layoutp'>{data.namaMentor}</p></Td>
                                        <Td className='layout'><p className='layoutp'>{data.emailMentor}</p></Td>
                                        <Td className='layout'><p className='layoutp'>{data.namaProposal}</p></Td>
                                        <Td className='layout'><p className='layoutp'>{data.jumlahMentee}</p></Td>
                                        <Td className='layout'><p className='layoutp'>{data.jumlahLaporanBelumDiperiksa}</p></Td>
                                        <Td className='layout'><p className='layoutp'>{data.posisi}</p></Td>
                                        <Td>
                                            <Button 
                                                onClick={() => navigate(`/mitra/profile/mentor/list-mentee/${data.idMentor}/${id}`)}
                                                size='xs' rounded={'xl'} colorScheme='purple' variant='solid' fontSize={'xs'} margin={'0 10px'}>
                                                Lihat Mentee
                                            </Button>
                                        </Td>
                                    </Tr>
                                )}
                            </Tbody>
                        </Table>
                    : 
                    <Text fontSize={"large"} fontWeight={'600'}>Belum ada mentor yang Anda tambahkan</Text>
                    }
                    {data.length > 0 ? (<HorizontalBar last={true} />) : null}
                                {pageNumbers.length > 1 && (
                                    <Pagination
                                    style={{margin: 'auto'}}>
                                        <PaginationButton onClick={() => 
                                            setCurrentPage(1)}>
                                            &lt;&lt;
                                        </PaginationButton>
                                        <PaginationButton onClick={() => 
                                            currentPage === 1 ? setCurrentPage(1) : setCurrentPage(currentPage-1)}>
                                            &lt;
                                        </PaginationButton>
                                        {pageNumbers.map((page) => (
                                            <PaginationButton
                                                unshow={
                                                    currentPage > 2 && pageNumbers.length - currentPage > 1
                                                    ? Math.abs(currentPage - page) > 2
                                                    : pageNumbers.length - currentPage < 2
                                                    ? pageNumbers.length - page > 4
                                                    : page > 5
                                                }
                                                active={currentPage === page}
                                                onClick={() => setCurrentPage(page)}
                                                >
                                                    {page}
                                            </PaginationButton>
                                        ))}
                                        <PaginationButton
                                            onClick={() =>
                                            currentPage === pageNumbers.length
                                                ? setCurrentPage(pageNumbers.length)
                                                : setCurrentPage(currentPage + 1)
                                            }
                                        >
                                            &gt;
                                        </PaginationButton>
                                        <PaginationButton onClick={() => setCurrentPage(pageNumbers.length)}>
                                            &gt;&gt;
                                        </PaginationButton>
                                    </Pagination>
                                )}
                        </VStack>
                    </Box>
                </VStack>
            </Center>
        </div>   
    );
}

export default ListMentor;